interface ProgressBarProps {
  percentage: number
  dangerBelow?: number
  yellowBelow?: number
  className?: string
}

const ProgressBar = ({ percentage, dangerBelow, yellowBelow, className }: ProgressBarProps) => {
  const clampedPercentage = Math.min(Math.max(percentage, 0), 100)
  const color =
    dangerBelow && percentage <= dangerBelow
      ? "var(--danger)"
      : yellowBelow && percentage <= yellowBelow
        ? "var(--warning)"
        : "var(--primary)"
  return (
    <>
      <style jsx>{`
        .progressBar {
          --border-radius: 10px;
          --padding: 3px;

          position: relative;
          background-color: var(--light);
          border-radius: calc(var(--border-radius) - var(--padding));
          padding: var(--padding);

          height: 20px;
          width: 100%;
        }

        .progressBar::before {
          content: "";
          position: absolute;
          background-color: ${color};
          width: calc(${clampedPercentage}% - var(--padding) * 2);
          height: calc(100% - var(--padding) * 2);
          border-radius: var(--border-radius);
          transition:
            width 0.3s ease-in-out,
            background-color 0.2s ease-in-out;
        }
      `}</style>
      <div className={`progressBar ${className ?? ""}`} />
    </>
  )
}

export default ProgressBar
